import {useQuery} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';
import {isFirstLoad} from 'nutshell-core/utils/graphql-loading';

import type {
    GetContactLegacyId as GetContactLegacyIdQuery,
    GetContactLegacyIdVariables,
} from 'nutshell-graphql-types';

import GET_CONTACT_LEGACY_ID from '../queries/get-contact-legacy-id.graphql';

export function useGetContactLegacyId(contactId: string): {
    legacyId: string | undefined;
    shouldShowLegacyId: boolean;
    isLoading: boolean;
    isFirstLoad: boolean;
    error: string | null | undefined;
    refetch: () => Promise<any>;
} {
    const {data, loading, error, refetch, networkStatus} = useQuery<
        GetContactLegacyIdQuery,
        GetContactLegacyIdVariables
    >(GET_CONTACT_LEGACY_ID, {
        variables: {contactId},
        notifyOnNetworkStatusChange: true,
        fetchPolicy: 'cache-and-network',
    });

    return {
        legacyId: data?.contact?.legacyId ?? undefined,
        shouldShowLegacyId: data?.contact?.shouldShowLegacyId ?? false,
        isLoading: loading,
        isFirstLoad: isFirstLoad(networkStatus),
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
        refetch,
    };
}
